<template>
  <div v-if="personalData !== null">
    <div class="w-full bg-white pb-16 tab-content mt-6">
      <div
        class="font-medium text-lg px-4 py-8 mb-4 flex item-center justify-between border-b"
      >
        <h2>
          {{ $t('message.selfService.infoEmployee.personalInfo.personal') }}
        </h2>
      </div>

      <div class="px-4">
        <div class="flex flex-wrap -mx-4">
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.userName"
              readonly
              color="primary"
              name="dataContact.usuario"
              class="w-full text-zt-lg"
              outlined
              :label="
                $t('message.selfService.infoEmployee.personalInfo.usuario')
              "
              data-vs-input="personal-user"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.email"
              readonly
              name="mail"
              class="w-full"
              outlined
              :label="$t('message.selfService.infoEmployee.personalInfo.mail')"
              data-vs-input="personal-mail"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.firstName"
              readonly
              color="primary"
              name="nombre"
              class="w-full text-zt-lg"
              outlined
              :label="
                $t('message.selfService.infoEmployee.personalInfo.nombre')
              "
              data-vs-input="personal-nombre"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.lastName"
              readonly
              name="personalSurname"
              class="w-full"
              outlined
              :label="
                $t('message.selfService.infoEmployee.personalInfo.apellido')
              "
              data-vs-input="personal-surname"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.personalIdNumber"
              readonly
              color="primary"
              name="personalPhone"
              class="w-full text-zt-lg"
              outlined
              :label="$t('message.selfService.infoEmployee.personalInfo.dni')"
              data-vs-input="personal-dni"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2" v-if="companyCountry === 'ar'">
            <zt-input
              v-model="personalData.laborIdNumber"
              readonly
              name="personalCuil"
              class="w-full"
              outlined
              :label="$t('message.selfService.infoEmployee.personalInfo.cuil')"
              data-vs-input="personal-cuil"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.birthDate"
              readonly
              color="primary"
              name="fecha_nacimiento"
              class="w-full text-zt-lg"
              outlined
              :label="
                $t(
                  'message.selfService.infoEmployee.personalInfo.fecha_nacimiento'
                )
              "
              data-vs-input="fecha_nacimiento"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.hireDate"
              readonly
              name="fechaContratacion"
              class="w-full"
              outlined
              :label="
                $t(
                  'message.selfService.infoEmployee.personalInfo.fecha_contratacion'
                )
              "
              data-vs-input="personal-fecha-contratacion"
            />
          </div>
          <div class="w-full md:w-1/2 p-4 pr-2">
            <zt-input
              v-model="personalData.fileNumber"
              readonly
              color="primary"
              name="personalPhone"
              class="w-full text-zt-lg"
              outlined
              :label="
                $t('message.selfService.infoEmployee.personalInfo.fileNumber')
              "
              data-vs-input="fileNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="w-full bg-white pb-16 tab-content mt-16">
      <div
        class="font-medium text-lg px-4 py-8 mb-4 flex  item-center justify-between border-b"
      >
        <h2>
          {{ $t('message.selfService.infoEmployee.personalInfo.orgData') }}
        </h2>
      </div>
      <div class="px-4">
        <div class="flex flex-wrap md:flex-no-wrap">
          <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
            <zt-input
              v-model="personalData.sector"
              readonly
              color="primary"
              name="sectionCompany"
              class="w-full text-zt-lg"
              outlined
              :label="
                $t(
                  'message.selfService.infoEmployee.personalInfo.sectionCompany'
                )
              "
              data-vs-input="personal-sectionCompany"
            />
          </div>
          <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
            <zt-input
              v-model="personalData.location"
              readonly
              name="locationCompany"
              class="w-full"
              outlined
              :label="
                $t(
                  'message.selfService.infoEmployee.personalInfo.locationCompany'
                )
              "
              data-vs-input="locationCompany"
            />
          </div>
        </div>
        <div class="flex flex-wrap md:flex-no-wrap">
          <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
            <zt-input
              v-model="personalData.position"
              readonly
              color="primary"
              name="cargo"
              class="w-full text-zt-lg"
              outlined
              :label="$t('message.selfService.infoEmployee.personalInfo.cargo')"
              data-vs-input="cargo"
            />
          </div>
          <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
            <zt-input
              v-model="personalData.reportTo"
              readonly
              name="reporta_a"
              class="w-full"
              outlined
              :label="
                $t('message.selfService.infoEmployee.personalInfo.reporta_a')
              "
              data-vs-input="reporta_a"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full md:w-2/3 m-6 py-6">
      <zt-alert color="info" filled :closeIcon="false">
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.selfService.infoEmployee.tab.emptyTab') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserContactInfo',
  props: {
    personalData: { type: Object }
  },
  data() {
    return {
      companyCountry: this.$store.state.locale
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
